import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  remitterAccountApprove,
  remitterAccountDetailsById,
  remitterAccountReject,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const RemitterAccountSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showRejectLoader, setShowRejectLoader] = useState(false);
  const [showApproveLoader, setShowApproveLoader] = useState(false);

  const services = useSelector((state) => state.refreshToken.services);

  const hasMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") && services?.includes("VAccountBalance"));

  const hasLiveMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") &&
      services?.includes("VItemisedStatement"));

  const { remitterAccountDetailsData } = useSelector(
    (state) => state.remitterAccount,
  );

  const remitterAccountData = remitterAccountDetailsData;

  const consolidatedBankHandler = () => {
    navigate("/owner_account_dashboard/consolidated_bank_statement", {
      state: {
        data: id,
        flow: "new_match_txn",
        remName: remitterAccountDetailsData?.name,
      },
      replace: true,
    });
  };

  const liveBankHandler = () => {
    navigate("/owner_account_dashboard/consolidated_live_statement", {
      replace: true,
      state: {
        data: id,
        flow: "new_match_txn",
        remName: remitterAccountDetailsData?.name,
      },
    });
  };

  const createAccountHandler = () => {
    navigate("/remitter_account_dashboard/create_remitter_account", {
      replace: true,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
      { replace: true },
    );
  };

  const dashboardHandler = () => {
    navigate("/remitter_account_dashboard", { replace: true });
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const accountApproval = () => {
    (async () => {
      setShowApproveLoader(true);
      toast.dismiss();
      UniversalRefreshToast("approvalaccountsRefresh");
      let response = await dispatch(remitterAccountApprove({ id }));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });

        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.remitter_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      setShowRejectLoader(true);
      toast.dismiss();
      UniversalRefreshToast("accountsRefresh");
      let response = await dispatch(
        remitterAccountReject({
          id,
          rejection_reason: declineReason,
        }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account rejected successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        });

        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.remitter_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        });
        setRejectPopup(false);
      }
    })();
  };
  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const primaryBtn = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--positive-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--positive-bg)",
    hoverOption: "dark",
  };

  const outlineBtn = {
    enabledBgColor: "var(--bg-positive-bg)",
    enabledTextColor: "var(--text-primary)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    outLineColor: "var(--text-primary)",
    hoverOption: "dark",
  };

  const buttonRows = [
    ...(services?.includes("REAAccount") ||
    (services?.includes("Admin") &&
      remitterAccountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isLoaderNeeded: showRejectLoader,
              isLoading: showRejectLoader,
              isDisabled: showApproveLoader,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isLoaderNeeded: showApproveLoader,
              isLoading: showApproveLoader,
              isDisabled: showRejectLoader,
            },
          ],
        ]
      : []),

    [
      {
        ...primaryBtn,
        btnText: "Match in bank statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: () => {
          if (hasMatchPermission) {
            !showApproveLoader && consolidatedBankHandler();
          } else {
            const requiredServices = ["AMapping", "VAccountBalance"];

            const unavailableServices = requiredServices.filter(
              (service) => !services?.includes(service),
            );

            navigate("/feature_not_assigned", {
              state: {
                unavailableService: unavailableServices,
              },
            });
          }
        },

        isDisabled:
          showRejectLoader || showApproveLoader || !hasMatchPermission,
      },
      {
        ...primaryBtn,
        btnText: "Match in live statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: () => {
          if (hasLiveMatchPermission) {
            !showApproveLoader && liveBankHandler();
          } else {
            const requiredServices = ["AMapping", "VItemisedStatement"];

            const unavailableServices = requiredServices.filter(
              (service) => !services?.includes(service),
            );

            navigate("/feature_not_assigned", {
              state: {
                unavailableService: unavailableServices,
              },
            });
          }
        },
        isDisabled:
          showRejectLoader || showApproveLoader || !hasLiveMatchPermission,
      },
      {
        ...primaryBtn,
        btnText: "Create account",
        icon: ICONS.CREATE_NEW_ACCOUNT,
        handleFunction: () => {
          !showApproveLoader && createAccountHandler();
        },
        isDisabled: showRejectLoader || showApproveLoader,
      },
      {
        ...primaryBtn,
        btnText: "View details",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: () => {
          !showApproveLoader && viewDetailsHandler();
        },
        isDisabled: showRejectLoader || showApproveLoader,
      },
      {
        ...outlineBtn,
        btnText: "Go to dashboard",
        icon: ICONS.GO_TO_DASHBOARD,
        handleFunction: () => {
          !showApproveLoader && dashboardHandler();
        },
        imgColor: "var(--text-primary)",
        isDisabled: showRejectLoader || showApproveLoader,
      },
    ],
  ];

  useEffect(() => {
    dispatch(remitterAccountDetailsById({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;

      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      // if (event.key === "Enter") {
      //   event.preventDefault();
      //   event.stopPropagation();

      //   if (
      //     rejectPopup &&
      //     declineReason.trim().length >=
      //       GlobalConfiguration.rejectReasonMinLength
      //   ) {
      //     accountRejected();
      //   }
      // }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [declineReason, rejectPopup]);

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            bulletPoints={[
              "Once rejected, this account can no longer be used for matching the transactions.",
            ]}
            inputAdornment={""}
            noteColor="text-secondary"
            inputPlaceholder={"Reason"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showRejectLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showRejectLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showRejectLoader ? true : false}
            btnTwoIsLoading={showRejectLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={"Remitter account created successfully and awaiting approval."}
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: remitterAccountData?.name,
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array?.isArray(remitterAccountData?.labels) &&
                    remitterAccountData?.labels?.length >
                      GlobalConfiguration?.lengthCheckZero
                      ? remitterAccountData.labels.map((l) => l).join(", ")
                      : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: remitterAccountData?.id,
                  leftSubTitle: "Account ID",
                  copyText: remitterAccountData?.id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default RemitterAccountSuccess;
